import React from 'react';
import styles from './button.module.css';
import { cx } from '../../../helper/cx';

/**
 * @typedef {Object} ButtonProps
 * @property {string} [label]
 * @property {React.ReactNode} [children]
 * @property {() => void} [onClick]
 * @property {boolean} [disabled]
 * @property {string} [customId]
 * @property {string} [className]
 * @property {"button" | "submit" | "reset"} [type]
 * @property {React.ReactNode} [left]
 * @property {React.ReactNode} [right]
 * @property {"primary" | "secondary"} [variant]
 * @property {boolean} [fullWidth]
 */

/**
 * @param {ButtonProps} props
 */
const Button = ({
  node = 'default',
  label,
  children,
  onClick,
  disabled = false,
  customId = 'default-button-id',
  className = '',
  type = 'button',
  left,
  right,
  variant = 'primary',
  fullWidth = false,
}) => {
  const hasSides = left || right;

  return (
    <button
      id={customId}
      data-element-id={customId}
      type={type}
      className={cx(
        `${node}-button`,
        styles.button,
        styles[variant],
        { [styles.fullWidth]: fullWidth },
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={cx(styles.content, { [styles.withSides]: hasSides })}>
        {left && <span className={styles.side}>{left}</span>}
        <span>{label || children}</span>
        {right && <span className={styles.side}>{right}</span>}
      </span>
    </button>
  );
};

export default Button;
